if (!Math.log10) {
    Math.log10 = x => Math.log(x) * Math.LOG10E;
}
